import {
  type GenerateStyle,
  genComponentStyleHook,
  type FullToken,
} from "antd/es/theme/internal";
import { drawerPrefixCls } from "@/base/components/drawer/Drawer.component";
import { THEME_PREFIX } from "@/base/constant";

const genStyle: GenerateStyle<FullToken<"Drawer">> = ({
  colorBgIcon,
  padding,
  fontSizeIcon,
  paddingBlockHeader,
  paddingBlockFooter,
  colorBgElevated,
}: any) => ({
  [`.${drawerPrefixCls}`]: {
    [`.${drawerPrefixCls}-content-wrapper`]: {
      maxWidth: `calc(100vw - ${fontSizeIcon + 2}px) !important`,
    },

    [`&.${drawerPrefixCls}-right`]: {
      [`.${THEME_PREFIX} .${drawerPrefixCls}-close`]: {
        top: "16px",
        left: `-${fontSizeIcon}px`,
      },
    },
    [`&.${drawerPrefixCls}-left`]: {
      [`.${THEME_PREFIX} .${drawerPrefixCls}-close`]: {
        top: "16px",
        right: `-${fontSizeIcon}px`,
      },
    },
    [`&.${drawerPrefixCls}-bottom`]: {
      [`.${THEME_PREFIX} .${drawerPrefixCls}-close`]: {
        top: `-${fontSizeIcon}px`,
        right: "16px",
      },
    },
    [`&.${drawerPrefixCls}-top`]: {
      [`.${THEME_PREFIX} .${drawerPrefixCls}-close`]: {
        bottom: `-${fontSizeIcon}px`,
        right: "16px",
      },
    },

    [`.${THEME_PREFIX}`]: {
      [`&.${drawerPrefixCls}-content`]: {
        position: "static",

        [`&:not(.${drawerPrefixCls}-has-no-title)`]: {
          [`.${drawerPrefixCls}-header`]: {
            paddingTop: parseInt(paddingBlockFooter) * 2,
          },
        },

        [`.${drawerPrefixCls}-footer`]: {
          backgroundColor: `${colorBgElevated}`,
          paddingBlock: paddingBlockFooter,
          position: "sticky",
          bottom: 0,
        },

        [`.${drawerPrefixCls}-header`]: {
          backgroundColor: `${colorBgElevated}`,
          paddingBlock: paddingBlockHeader,
          paddingInline: `${padding}px`,
        },

        [`.${drawerPrefixCls}-body`]: {
          flex: "none",
          paddingBlock: 2,
          overflow: "hidden",
          paddingInline: `${padding}px`,
        },

        [`.${drawerPrefixCls}-close`]: {
          position: "absolute",
          borderRadius: "50%",
          width: `${fontSizeIcon * 2}px`,
          height: `${fontSizeIcon * 2}px`,
          backgroundColor: `${colorBgIcon}`,
          zIndex: 2,
        },
      },
    },
  },
});

export const useDrawerStyle = genComponentStyleHook(
  ["Drawer", "cso"],
  (token) => {
    return [genStyle(token)];
  },
);
